import React, { useEffect, useRef } from 'react';
import { Input, Switch, Typography } from 'antd';
import { validate as validateEmail } from 'email-validator';
const { Text } = Typography;
export const transformUserInfoDataToMainTableData = (userInfoData) => {
    if (userInfoData) {
        return Object.values(userInfoData.users).map(({ base }) => base);
    }
    return [];
};
const transformMixedObjectToKVStringArray = (mixedObject) => Object.entries(mixedObject).map(([key, value]) => ({
    key,
    value: Object(value) === value || typeof value === 'boolean' ? JSON.stringify(value) : value,
}));
export const transformSelectedUserToUserBaseTableData = (selectedUser) => {
    if (selectedUser) {
        return transformMixedObjectToKVStringArray(selectedUser.base);
    }
    return [];
};
export const transformSelectedUserToUserTeamTableData = (selectedUser) => {
    if (selectedUser) {
        return transformMixedObjectToKVStringArray(selectedUser.team);
    }
    return [];
};
export const transformSelectedUserToUserMetaDataTableData = (selectedUser) => {
    if (selectedUser) {
        return transformMixedObjectToKVStringArray(selectedUser.metadata);
    }
    return [];
};
export const alphabetSorterFactory = (fieldName) => (a, b) => a[fieldName].localeCompare(b[fieldName]);
export const autoFocusedFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm }) => {
    const inputRef = useRef();
    useEffect(() => {
        if (inputRef.current) {
            setTimeout(() => inputRef.current.focus(), 100);
        }
    });
    return (React.createElement(Input, { ref: (input) => {
            inputRef.current = input;
        }, placeholder: "type stuff :-)", onChange: (e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []);
            confirm({ closeDropdown: false });
        }, onPressEnter: () => {
            confirm();
        }, onKeyUp: (event) => {
            const key = event.key || event.keyCode;
            const inputValue = event.currentTarget.value.trim();
            if (key === 'Escape' || key === 27) {
                confirm();
            }
        } }));
};
export const onFilterSubstringSearchFactory = (fieldName, caseSensitive = false) => (value, record) => {
    if (caseSensitive) {
        return record[fieldName].includes(value);
    }
    return record[fieldName].toLocaleLowerCase().includes(value.toLocaleLowerCase());
};
export const ColumnSwitcherator = ({ columnName, callback, checked, }) => (React.createElement(Switch, { defaultChecked: checked, onChange: (e) => callback(columnName, e), checkedChildren: `${columnName} ON`, unCheckedChildren: `${columnName} OFF` }));
export const columnDefinitionFactory = (dataIndex, title) => ({
    dataIndex,
    title: React.createElement(Text, { ellipsis: true }, title),
    sorter: alphabetSorterFactory(dataIndex),
    filterDropdown: autoFocusedFilterDropdown,
    onFilter: onFilterSubstringSearchFactory(dataIndex),
    render: (text) => (React.createElement(Text, { ellipsis: dataIndex !== 'email' ? { tooltip: true } : false, style: { width: 90 } }, text)),
});
export const rawEmailInputToEmailArray = (rawEmailString) => rawEmailString.replace(/[ ,]+/g, ' ').trim().split(' ');
export const validateEmailArray = (emailArray) => emailArray.every((email) => validateEmail(email));
//# sourceMappingURL=helpers.js.map